import { cartAdministration } from './cart-administration-en.i18n';

export const en = {
  cartAdministration,
};
